import { useRef, useState, useLayoutEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getKeystoreItem, setKeystoreItem } from 'edrolo/domains/profile';

const genKey = (id) => `user_dismissed_${id}`;

const getKeystoreItems = (state, keys) =>
  keys.map((key) => getKeystoreItem(state, key));

function usePrerequisites(prerequisiteIds = []) {
  // Check whether all of the given keys are already true
  const prerequisiteKeys = prerequisiteIds.map(genKey);
  const prerequisiteValues = useSelector((state) =>
    getKeystoreItems(state, prerequisiteKeys)
  );
  return prerequisiteValues.every((i) => i);
}

export function useDismissable(id, prerequisiteIds = []) {
  const key = genKey(id);

  const dispatch = useDispatch();
  const isDismissed = useSelector((state) => getKeystoreItem(state, key));
  const prerequisitesDismissed = usePrerequisites(prerequisiteIds);

  const setDismissed = useCallback(
    () => dispatch(setKeystoreItem.signal(key, true)),
    [dispatch, key]
  );
  const shouldShow = prerequisitesDismissed && !isDismissed;

  return [shouldShow, setDismissed];
}

export function useRect() {
  const ref = useRef();
  const [rect, setRect] = useState();

  const updateRect = () => {
    if (ref.current) {
      setRect(ref.current.getBoundingClientRect());
    }
  };

  useLayoutEffect(() => {
    updateRect();
    window.addEventListener('resize', updateRect);
    return () => {
      window.removeEventListener('resize', updateRect);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, [ref.current]);

  return [ref, rect];
}
